import { createReducer, on } from '@ngrx/store';
import * as gamePlanAction from './../actions/gameplan.action';
import { gamePlanActive } from './../models/gameplan.model';

export interface gamePlanState {
  gamePlanActive: any[];
  loading: boolean;
  error: any;
}

const initialState: gamePlanState = {
  gamePlanActive: [],
  loading: false,
  error: null
};

export const gamePlanReducer = createReducer(
  initialState,
  on(gamePlanAction.loadGamePlan, state => ({ ...state, loading: true })),
  on(gamePlanAction.loadGamePlanSuccess, (state, { gamePlanActive }) => ({ ...state, gamePlanActive:gamePlanActive, loading: false })),
  on(gamePlanAction.loadGamePlanFailure, (state, { error }) => ({ ...state, error, loading: false }))
);



export interface studentJourneyState {
    journeyData: any[];
    loading: boolean;
    error: any;
  }
  
  const initialStudentState: studentJourneyState = {
    journeyData: [],
    loading: false,
    error: null
  };
  
  export const studentJourneyReducer = createReducer(
    initialStudentState,
    on(gamePlanAction.loadGamePlanJourney, state => ({ ...state, loading: true })),
    on(gamePlanAction.loadGamePlanJourneySuccess, (state, { journeyData }) => ({ ...state, journeyData, loading: false })),
    on(gamePlanAction.loadGamePlanFailure, (state, { error }) => ({ ...state, error, loading: false }))
  );
  